import React from 'react'
import {Box, Stack, Typography} from '@mui/material'
import {useTranslation} from 'react-i18next'
import {PAYMENT_COLORS} from './constants'

export default function GatewayStatus({connected}: {connected: boolean}) {
  const {t} = useTranslation()
  const color = connected ? PAYMENT_COLORS.success : PAYMENT_COLORS.textMuted
  const label = connected
    ? (t('payment.status.connected') as string)
    : (t('payment.status.ready') as string)

  return (
    <Stack
      direction='row'
      alignItems='center'
      gap='6px'
      sx={{
        px: '8px',
        py: '4px',
        borderRadius: '6px',
        backgroundColor: connected ? 'rgba(16,185,129,0.1)' : PAYMENT_COLORS.background,
        border: `1px solid ${connected ? 'rgba(16,185,129,0.35)' : PAYMENT_COLORS.border}`,
      }}
    >
      <Box
        sx={{
          width: 8,
          height: 8,
          borderRadius: '50%',
          backgroundColor: color,
          flexShrink: 0,
        }}
      />
      <Typography fontSize={12} fontWeight={600} color={PAYMENT_COLORS.textSecondary}>
        {label}
      </Typography>
    </Stack>
  )
}
